import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Components
import { Icon } from 'components';
import { Button, Text } from '@beef/ui-kit';

// Utils
import { maskPhoneNumber } from 'utils/validators';

// Constants
import { FAMILY_URL, INVITATION_STATUS } from '../../constants';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const COMPACT_NUMBER_LIST_LENGTH = 3;

const NumberListFamily = ({ numberList }) => {
  const [shownNumbers, setShownNumbers] = useState([]);
  const history = useHistory();

  const getVisibleNumbers = (cellNumbers) => {
    const listLength = cellNumbers.length;
    if (listLength > COMPACT_NUMBER_LIST_LENGTH) {
      return cellNumbers.slice(0, 2);
    }
    return cellNumbers;
  };

  const showAllNumbers = () => {
    setShownNumbers(numberList);
  };

  const hideExtraNumbers = () => {
    setShownNumbers(getVisibleNumbers(numberList));
  };

  useEffect(() => {
    setShownNumbers(getVisibleNumbers(numberList));
  }, [numberList]);

  const getButtonIconName = useCallback((status) => {
    if (status === INVITATION_STATUS.sent) {
      return 'clock';
    }
    return 'settings';
  }, [numberList]);

  const handleSettingsBtnClick = useCallback((ctn) => () => {
    history.replace(`${FAMILY_URL}/${ctn}`);
  }, []);

  return (
    <>
      <ul className={cn('list')}>
        {shownNumbers.map((number) => (
          <li key={number.ctn} className={cn('list-item')}>
            <div className={cn('list-item__avatar')}>
              <img src={number.image} alt="номер телефона" />
            </div>
            <div className={cn('list-item__cell-number')}>
              <Text
                color="grey95"
                size="size5-m"
              >
                {maskPhoneNumber(number.ctn)}
              </Text>
            </div>
            <div className={cn('list-item__status')}>
              <Text
                color="grey50"
                size="size5-r-s"
              >
                {number.statusText}
              </Text>
            </div>
            <div className={cn('list-item__settings')}>
              <Button
                variant="plain"
                onClick={handleSettingsBtnClick(number.ctn)}
              >
                <Icon name={getButtonIconName(number.status)} />
              </Button>
            </div>
          </li>
        ))}
      </ul>
      {(numberList.length > COMPACT_NUMBER_LIST_LENGTH) && (
      <div>
        {(numberList.length !== shownNumbers.length) && (
        <div>
          <Button
            variant="plain"
            onClick={showAllNumbers}
          >
            <div className={cn('show-button')}>
              <div className={cn('show-button__icon')}>
                <Text
                  color="scarlet"
                  size="size5-m"
                >
                  +
                  {numberList.length - shownNumbers.length}
                </Text>
              </div>
              <Text
                color="grey95"
                size="size5-m"
              >
                {`Ещё ${numberList.length - shownNumbers.length} номера`}
              </Text>
              <Icon name="arrow" className={cn('show-button__arrow')} />
            </div>
          </Button>
        </div>
        )}
        {(numberList.length === shownNumbers.length) && (
        <div>
          <Button
            variant="plain"
            onClick={hideExtraNumbers}
          >
            <div className={cn('hide-button')}>
              <Text
                color="grey95"
                size="size5-m"
              >
                Свернуть номера
              </Text>
              <Icon name="arrow" className={cn('hide-button__arrow')} />
            </div>
          </Button>
        </div>
        )}
      </div>
      )}
    </>
  );
};

NumberListFamily.propTypes = {
  numberList: PropTypes.arrayOf({
    ctn: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    image: PropTypes.string,
  }),
};

export { NumberListFamily };
